import * as Types from '../../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateDomainMutationVariables = Types.Exact<{
  domainType: Types.DomainType;
  name: Types.Scalars['String']['input'];
  description?: Types.InputMaybe<Types.Scalars['String']['input']>;
  dialoutPrefix?: Types.InputMaybe<Types.Scalars['String']['input']>;
  specialNumbersDialoutPrefix?: Types.InputMaybe<Types.Scalars['String']['input']>;
  shortNumbersLength: Types.Scalars['Int']['input'];
  preferDisplayNamesForStationNames: Types.Scalars['Boolean']['input'];
  locationName: Types.Scalars['String']['input'];
  locationDescription: Types.Scalars['String']['input'];
  locationPilotNumber: Types.Scalars['String']['input'];
  smtpAuthEnabled: Types.Scalars['Boolean']['input'];
  smtpUsername?: Types.InputMaybe<Types.Scalars['String']['input']>;
  smtpUserpass?: Types.InputMaybe<Types.Scalars['String']['input']>;
  privateRoutingType: Types.PrivateRoutingType;
  defaultUserPackage?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type CreateDomainMutation = { __typename?: 'Mutation', createDomain?: { __typename?: 'SaveResult', id?: number | null, errors?: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string }> | null } | null };


export const CreateDomainDocument = gql`
    mutation CreateDomain($domainType: DomainType!, $name: String!, $description: String, $dialoutPrefix: String, $specialNumbersDialoutPrefix: String, $shortNumbersLength: Int!, $preferDisplayNamesForStationNames: Boolean!, $locationName: String!, $locationDescription: String!, $locationPilotNumber: String!, $smtpAuthEnabled: Boolean!, $smtpUsername: String, $smtpUserpass: String, $privateRoutingType: PrivateRoutingType!, $defaultUserPackage: String) {
  createDomain(
    domainType: $domainType
    name: $name
    description: $description
    dialoutPrefix: $dialoutPrefix
    specialNumbersDialoutPrefix: $specialNumbersDialoutPrefix
    shortNumbersLength: $shortNumbersLength
    preferDisplayNamesForStationNames: $preferDisplayNamesForStationNames
    locationName: $locationName
    locationDescription: $locationDescription
    locationPilotNumber: $locationPilotNumber
    smtpAuthEnabled: $smtpAuthEnabled
    smtpUsername: $smtpUsername
    smtpUserpass: $smtpUserpass
    privateRoutingType: $privateRoutingType
    defaultUserPackage: $defaultUserPackage
  ) {
    id
    errors {
      location
      context
      type
    }
  }
}
    `;
export type CreateDomainMutationFn = Apollo.MutationFunction<CreateDomainMutation, CreateDomainMutationVariables>;

/**
 * __useCreateDomainMutation__
 *
 * To run a mutation, you first call `useCreateDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDomainMutation, { data, loading, error }] = useCreateDomainMutation({
 *   variables: {
 *      domainType: // value for 'domainType'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      dialoutPrefix: // value for 'dialoutPrefix'
 *      specialNumbersDialoutPrefix: // value for 'specialNumbersDialoutPrefix'
 *      shortNumbersLength: // value for 'shortNumbersLength'
 *      preferDisplayNamesForStationNames: // value for 'preferDisplayNamesForStationNames'
 *      locationName: // value for 'locationName'
 *      locationDescription: // value for 'locationDescription'
 *      locationPilotNumber: // value for 'locationPilotNumber'
 *      smtpAuthEnabled: // value for 'smtpAuthEnabled'
 *      smtpUsername: // value for 'smtpUsername'
 *      smtpUserpass: // value for 'smtpUserpass'
 *      privateRoutingType: // value for 'privateRoutingType'
 *      defaultUserPackage: // value for 'defaultUserPackage'
 *   },
 * });
 */
export function useCreateDomainMutation(baseOptions?: Apollo.MutationHookOptions<CreateDomainMutation, CreateDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDomainMutation, CreateDomainMutationVariables>(CreateDomainDocument, options);
      }
export type CreateDomainMutationHookResult = ReturnType<typeof useCreateDomainMutation>;
export type CreateDomainMutationResult = Apollo.MutationResult<CreateDomainMutation>;
export type CreateDomainMutationOptions = Apollo.BaseMutationOptions<CreateDomainMutation, CreateDomainMutationVariables>;